var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5562 13.4062L16.1007 13.859C16.1007 13.859 15.0181 14.9355 12.0631 11.9972C9.10812 9.05901 10.1907 7.98257 10.1907 7.98257L10.4775 7.69738C11.1841 6.99484 11.2507 5.86691 10.6342 5.04348L9.37326 3.35908C8.61028 2.33992 7.13596 2.20529 6.26145 3.07483L4.69185 4.63552C4.25823 5.06668 3.96765 5.62559 4.00289 6.24561C4.09304 7.83182 4.81071 11.2447 8.81536 15.2266C13.0621 19.4492 17.0468 19.617 18.6763 19.4651C19.1917 19.4171 19.6399 19.1546 20.0011 18.7954L21.4217 17.383C22.3806 16.4295 22.1102 14.7949 20.8833 14.128L18.9728 13.0894C18.1672 12.6515 17.1858 12.7801 16.5562 13.4062Z",
    fill: "#00A991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0bd527bc6878ddb96af584295ccc6781.svg";
export { ForwardRef as ReactComponent };